import { registerLocaleData } from '@angular/common';
import localeBg from '@angular/common/locales/bg';
import localeCs from '@angular/common/locales/cs';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeEt from '@angular/common/locales/et';
import localeFi from '@angular/common/locales/fi';
import localeFr from '@angular/common/locales/fr';
import localeHr from '@angular/common/locales/hr';
import localeHu from '@angular/common/locales/hu';
import localeIT from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localeLt from '@angular/common/locales/lt';
import localeLv from '@angular/common/locales/lv';
import localeNb from '@angular/common/locales/nb';
import localeNo from '@angular/common/locales/no';
import localePl from '@angular/common/locales/pl';
import localePt from '@angular/common/locales/pt';
import localeRo from '@angular/common/locales/ro';
import localeSk from '@angular/common/locales/sk';
import localeSv from '@angular/common/locales/sv';
import localeZhHans from '@angular/common/locales/zh-Hans';
import localeZhHant from '@angular/common/locales/zh-Hant';

export function registerLocales(): void {
  registerLocaleData(localeEN);
  registerLocaleData(localeIT);
  registerLocaleData(localeFr);
  registerLocaleData(localeEs);
  registerLocaleData(localeBg);
  registerLocaleData(localeHr);
  registerLocaleData(localePt);
  registerLocaleData(localeCs);
  registerLocaleData(localeSk);
  registerLocaleData(localeDe);
  registerLocaleData(localeHu);
  registerLocaleData(localePl);
  registerLocaleData(localeRo);
  registerLocaleData(localeNo);
  registerLocaleData(localeEt);
  registerLocaleData(localeFi);
  registerLocaleData(localeLv);
  registerLocaleData(localeLt);
  registerLocaleData(localeNb);
  registerLocaleData(localeSv);
  registerLocaleData(localeDa);
  registerLocaleData(localeZhHans);
  registerLocaleData(localeJa);
  registerLocaleData(localeKo);
  registerLocaleData(localeZhHant);
}
